import { useContext, useState, useEffect } from 'react';
import ConfigurationContext from '../Contexts/ConfigurationContext';

const useLocale = () => {
    const { configurationData } = useContext(ConfigurationContext);
    const [localeCode, setLocaleCode] = useState();
    const locale = configurationData?.find(element => element.name === "Locale");

    useEffect(() => {
        if (locale?.value) {
            setLocaleCode(locale.value);
        }
    }, [locale]);

    return localeCode;
}

export default useLocale